import * as wConst from "../consts/website-consts.js";
import {ShowSendProfileMessage} from "../actions/website-actions";

const initState = {
  ShowingImages: false,
  ForceXL: "",
  PageType: "home",
  UCMode: false,
  Loaded: false,
  PageLoaded: false,
  ShowingLogin: false,
  ShowingRegister: false,
  Pages: [],
  Profile: null,
  Paths: [],
  Translations: {},
  TranslationsLocal: "nl",
  ShowingFilter: true,
  Warning: {
    Type: "NONE", //"INFO,WARN,ERROR"
    Showing: false,
    Message: ""
  },
  User: {
    UserId: 0,
  },
  SendMessageProfile: {
    ShowingSendMessageProfile: false,
    Id: "0", Name: "", Image: "", Location: "", Slogan: ""
  },
  Support: {
    Status: wConst.SUPPORT_STATUS_NEW,
    Message: "",
    Response: {
      Guid: "",
      UserName: "",
      Name: "",
      EmailAddress: "",
      UserType: "",
      Text: "",
      DomainId: 0
    }
  },
  SeoSettings: {
    Showing: false,
    Preview: false,
    Status: "NONE",
    Data: {
      Id: 0,
      Path: "",
      Name: "",
      Title: "",
      KeyWords: "",
      Description: "",
      H1Text: "",
      H1TextBlock: "",
      RedirectUrl: "",
      BreadCrumb: "",
      BreadCrumbs: [],
      Flags: "",
      Tags: [],
      Language: {Name: "", Code: ""}
    }
  },
  ProfileMessage: {
    Showing: false,
    Status: wConst.MSG_STATUS_NEW,
    MessageType: "EMAIL", //SMS,CHAT
    Data: {}
  },
  SignUp: {
    Status: wConst.SIGNUP_STATUS_NEW,
    Message: "",
    Type: "member",
    Response: {

    }
  },
  Confirmation: {
    Status: wConst.CONFIRM_STATUS_NEW,
    Message: "",
    Response: {}

  },
  ResetPassword: {
    Status: wConst.RESET_STATUS_NEW,
    Message: "",
    Response: {}
  },
  Dictionary: {
    Loaded: false

  },
  SiteMap: {
    Loaded: false

  },
  Links: {
    Loaded: false, ApiResult: {Code: 500, Message: "New"}
  }

};


export const websiteReducer = (state=initState, action) => {
  const resetState = {
    ShowingImages: false,
    ForceXL: "",
    PageType: "home",
    UCMode: false,
    Loaded: false,
    PageLoaded: false,
    ShowingLogin: false,
    ShowingRegister: false,
    Pages: [],
    Profile: null,
    Paths: [],
    Translations: {},
    TranslationsLocal: "nl",
    ShowingFilter: true,
    Warning: {
      Type: "NONE", //"INFO,WARN,ERROR"
      Showing: false,
      Message: ""
    },
    User: {
      UserId: 0,
    },
    SendMessageProfile: {
      ShowingSendMessageProfile: false,
      Id: "0", Name: "", Image: "", Location: "", Slogan: ""
    },
    Support: {
      Status: wConst.SUPPORT_STATUS_NEW,
      Message: "",
      Response: {
        Guid: "",
        UserName: "",
        Name: "",
        EmailAddress: "",
        UserType: "",
        Text: "",
        DomainId: 0
      }
    },
    SeoSettings: {
      Showing: false,
      Preview: false,
      Status: wConst.SEO_STATUS_NEW,
      Data: {
        Id: 0,
        Path: "",
        Name: "",
        Title: "",
        KeyWords: "",
        Description: "",
        H1Text: "",
        H1TextBlock: "",
        RedirectUrl: "",
        BreadCrumb: "",
        BreadCrumbs: [],
        Flags: "",
        Tags: [],
        Language: {Name: "", Code: ""}
      }
    },
    ProfileMessage: {
      Showing: false,
      Status: wConst.MSG_STATUS_NEW,
      MessageType: "EMAIL", //SMS,CHAT
      Data: {}
    },
    SignUp: {
      Status: wConst.SIGNUP_STATUS_NEW,
      Message: "",
      Type: "member",
      Response: {

      }
    },
    Confirmation: {
      Status: wConst.CONFIRM_STATUS_NEW,
      Message: "",
      Response: {}

    },
    ResetPassword: {
      Status: wConst.RESET_STATUS_NEW,
      Message: "",
      Response: {}
    },
    Dictionary: {
      Loaded: false

    },
    SiteMap: {
      Loaded: false

    },
    Links: {
      Loaded: false, ApiResult: {Code: 500, Message: "New"}
    }


  };
  switch (action.type) {
    case wConst.ACTION_LINKBANNERS_PENDING: {
      state = {...state, Links: {...state.Links, Loaded: false}};
      break;
    }
    case wConst.ACTION_LINKBANNERS_FAILURE: {
      state = {...state, Links: {ApiResult: action.payload, Loaded: true,}};
      break;
    }
    case wConst.ACTION_LINKBANNERS_SUCCESS: {
      state = {...state, Links: {ApiResult: action.payload, Loaded: true,}};
      break;
    }
    case wConst.FETCH_SITEMAP_PENDING: {
      state = { ...state, SiteMap: {Loaded: false}};
      break;
    }
    case wConst.FETCH_SITEMAP_REJECTED: {
      state = { ...state, SiteMap: {Loaded: true, ApiResult: action.payload}};
      break;
    }
    case wConst.FETCH_SITEMAP_FULLFILLED: {
      state = { ...state, SiteMap: {Loaded: true, ApiResult: action.payload}};
      break;
    }
    case wConst.ACTION_SET_BLOGPATH: {
      state = {...state, Settings: {...state.Settings, BlogPath: action.payload}};
      break;
    }
    case wConst.ACTION_ENABLE_FORCEXL: {
      state = {...state, ForceXL: action.payload}
      break;
    }
    case wConst.ACTION_DISABLE_FORCEXL: {
      state = {...state, ForceXL: action.payload}
      break;
    }
    case wConst.RESET_STATUS_PENDING: {
      state = {...state, ResetPassword: {...state.ResetPassword, Status: wConst.RESET_STATUS_PENDING, Response: {ConfirmId: action.payload, Id: action.payload, Code: ""}}};
      break;
    }
    case wConst.RESET_STATUS_FAILED: {
      state = {...state, ResetPassword: {...state.ResetPassword, Status: wConst.RESET_STATUS_FAILED}};
      break;
    }
    case wConst.RESET_STATUS_SUCCESS: {
      state = {...state, ResetPassword: {...state.ResetPassword, Status: wConst.RESET_CONFIRM_STATUS_NEW, Message: action.payload}};
      break;
    }
    case wConst.RESET_CONFIRM_STATUS_NEW: {
      state = {...state, ResetPassword: {...state.ResetPassword, Status: wConst.RESET_CONFIRM_STATUS_NEW, Response: {ConfirmId: action.payload.Id, Code: action.payload.Code}, Message: "Enter the code from your email if not already there."}};
      break;
    }
    case wConst.RESET_CONFIRM_STATUS_SUCCESS: {
      state = {...state, ResetPassword: {...state.ResetPassword, Status: wConst.RESET_STATUS_NEW, Message: "", Response: {Id: "", Code: "", ConfirmId: ""}}};
      break;
    }

    case wConst.MSG_STATUS_VIEW: {
      state = {...state, ProfileMessage: {...state.ProfileMessage, Showing: true, Data: action.payload}};
      break;
    }
    case wConst.MSG_ACTION_CLOSE: {
      state = {...state, ProfileMessage: {...state.ProfileMessage, Showing: false, Status: wConst.MSG_STATUS_NEW}};
      break;
    }
    case wConst.MSG_STATUS_PENDING: {
      state = {...state, ProfileMessage: {...state.ProfileMessage, Showing: true, Status: wConst.MSG_STATUS_PENDING}};
      break;
    }
    case wConst.MSG_STATUS_SUCCESS: {
        state = {...state, ProfileMessage: {...state.ProfileMessage,Showing: false, Result: action.payload}};
        break;
    }
    case wConst.SEO_STATUS_VIEW: {
      state = {...state, SeoSettings: {...state.SeoSettings, Showing: true, Preview: false, Status: wConst.SEO_STATUS_LOADING}};
      break;
    }
    case wConst.SEO_ACTION_CLOSE: {
      state = {...state, SeoSettings: {...state.SeoSettings, Showing: false, Preview: false, Status: wConst.SEO_STATUS_NEW}};
      break;
    }
    case wConst.SEO_ACTION_PREVIEW: {
      state = {...state, SeoSettings: {...state.SeoSettings, Preview: true}};
      break;
    }
    case wConst.SEO_ACTION_EDIT: {
      state = {...state, SeoSettings: {...state.SeoSettings, Preview: false}};
      break;
    }
    case wConst.SEO_STATUS_LOADED: {
      state = {...state, SeoSettings: {...state.SeoSettings, Preview: false, Status: wConst.SEO_STATUS_VIEW, Data: action.payload}};
      break;
    }
    case wConst.ACTION_SET_PAGETYPE: {
      state = {...state, PageType: action.payload};
      break;
    }
    case wConst.CONFIRM_STATUS_SUCCESS: {
      state = {...state, Confirmation: {Status: wConst.CONFIRM_STATUS_SUCCESS}, Warning: {Showing: true, Type: "INFO", Message: action.payload}};
      break;
    }
    case wConst.CONFIRM_STATUS_FAILED: {
      state = {...state, Confirmation: {Status: wConst.CONFIRM_STATUS_FAILED}, Warning: {Showing: true, Type: "ERROR", Message: action.payload}};
      break;
    }
    case wConst.RESET_STATE: {
      state = resetState;
      break;
    }
    case wConst.ACTION_FETCH_DICT_PENDING: {
      state = { ...state, Dictionary: { Loaded: false }};
      break;
    }
    case wConst.ACTION_FETCH_DICT_FULFILLED: {
      state = { ...state, Dictionary: {...action.payload, Loaded: true }};
      break;
    }
    case wConst.ACTION_FETCH_DICT_REJECTED: {
      state = { ...state, Dictionary: {Loaded: false }, Warning: {Showing: true, Type: "ERROR", Message: action.payload}};
      break;
    }
    case wConst.SHOW_WARNING: {
      state = { ...state, Warning: action.payload };
      break;
    }
    case wConst.HIDE_WARNING: {
      state = { ...state, Warning: {Showing: false, Type: "NONE", Message: ""} };
      break;
    }
    case wConst.SIGNUP_SET_TYPE: {
      state = { ...state, SignUp: {...state.SignUp, Type: action.payload} };
      break;
    }
    case wConst.SIGNUP_STATUS_PENDING: {
      state = { ...state, SignUp: { ...state.SignUp, Status: wConst.SIGNUP_STATUS_PENDING } , Warning: {Showing: false, Type: "NONE", Message: ""} };
      break;
    }
    case wConst.SIGNUP_STATUS_FAILED: {
      state = { ...state, SignUp: { ...state.SignUp, Status: wConst.SIGNUP_STATUS_FAILED, Message: action.payload }, Warning: {Showing: true, Type: "ERROR", Message: action.payload} };
      break;
    }
    case wConst.SIGNUP_STATUS_SUCCESS: {
      state = { ...state, SignUp: { ...state.SignUp, Status: wConst.SIGNUP_STATUS_SUCCESS, Message: action.payload }, Warning: {Showing: true, Type: "INFO", Message: action.payload}, Confirmation: {...state.Confirmation, EmailAddress: action.EmailAddress} };
      break;
    }
    case wConst.ACTION_PROFILE_SENDMESSAGE: {
      state = {...state, SendMessageProfile: {...action.payload, ShowingSendMessageProfile: true}};
      break;
    }
    case wConst.ACTION_SUPPORT_GET_PENDING: {
      state = {...state, Support: {...state.Support, Response: {Response: "", Name: "", EmailAddress: "", DomainId: 0}}};
      break;
    }
    case wConst.ACTION_SUPPORT_GET_FULFILLED: {
      state = {...state, Support: {...state.Support, Response: action.payload}};
      break;
    }
    case wConst.ACTION_SUPPORT_SENDMESSAGE_PENDING: {
      state = {...state, Support: {Response:state.Support.Response, Status: wConst.SUPPORT_STATUS_PENDING, Message: ""}};
      break;
    }
    case wConst.ACTION_SUPPORT_SENDMESSAGE_FAILED: {
      state = {...state, Support: {Response:state.Support.Response, Status: wConst.SUPPORT_STATUS_FAILED, Message: action.payload}};
      break;
    }
    case wConst.ACTION_SUPPORT_SENDMESSAGE_FULFILLED: {
      state = {...state, Support: {Response:state.Support.Response, Status: wConst.SUPPORT_STATUS_SUCCESS, Message: action.payload}};
      break;
    }
    case wConst.ACTION_SAVE_PATHS: {
      state = {...state, Paths: action.payload};
      break;
    }
    case wConst.ACTION_FETCH_LOGIN_PENDING: {
      state = { ...state, User: { UserId: 0, LoginStatus: wConst.LOGIN_STATUS_PENDING}};
      break;
    }
    case wConst.ACTION_FETCH_LOGIN_REJECTED: {
      state = {...state, User: {UserId: 0, LoginStatus: wConst.LOGIN_STATUS_FAILED }};
      break;
    }
    case wConst.ACTION_LOGIN_CLEARERROR: {
      state = { ...state, User: { UserId: 0, LoginStatus: wConst.LOGIN_STATUS_GUEST, ErrorMessage: "" }};
      break;
    }
    case wConst.ACTION_FETCH_LOGIN_FULFILLED: {
      state = { ...state, User: {LoginStatus: wConst.LOGIN_STATUS_APPROVED }};
      break;
    }
    case wConst.ACTION_FETCH_WEBSITESETTINGS: {
      break;
    }
    case wConst.ACTION_SHOW_LOGIN: {
      state = {...state, ShowingLogin: true};
      break;
    }
    case wConst.ACTION_HIDE_LOGIN: {
      state = {...state, ShowingLogin: false};
      break;
    }
    case wConst.ACTION_FETCH_WEBSITESETTINGS_FULLFILLED: {
      state = {...state, Loaded: true, ...action.payload};
      let tPath = "/"; //window ? window.location.pathname : "/";
      state.Pages[tPath] = state.Page;
      if(action.payload.Profile) {
        state.Profile = action.payload.Profile;
      }
      break;
    }

    case wConst.ACTION_FETCH_PAGE_PENDING: {
      state = {...state, PageLoaded: false};
      break
    }
    case wConst.ACTION_FETCH_PAGE_FULLFILLED: {
      state = {...state, PageLoaded: true, Page: action.payload};
      let tPath = action.payload.Path; //window.location.pathname;
      state.Pages[tPath] = state.Page;
      if(action.payload.Profile) {
        state.Profile = action.payload.Profile;
      }
      break;
    }

    case wConst.ACTION_HIDE_FILTER: {
      state = {...state, ShowingFilter: false};
      break;
    }
    case wConst.ACTION_SHOW_FILTER: {
      state = {...state, ShowingFilter: true};
      break;
    }
    case wConst.ACTION_SHOWINGIMAGES: {
      state = {...state, ShowingImages: true};
      break;
    }
    case wConst.ACTION_HIDINGIMAGES: {
      state = {...state, ShowingImages: false};
      break;
    }
    default: {
      break;
    }

  }
  return state;
};

